module.exports = __webpack_public_path__ + "static/img/histoire-thumb.b348c4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/histoire-thumb.jpg
// module id = 33
// module chunks = 0